import React from 'react';
import { motion } from 'framer-motion';
import { Skeleton } from '@/components/ui/skeleton';
import { TableRow, TableCell } from '@/components/ui/table';

export default function CompanyFundsLoading({ rows = 5 }: { rows?: number }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <TableRow key={`loading-${i}`}>
          <TableCell className="w-[140px]">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3, delay: i * 0.05 }}
            >
              <Skeleton className="h-4 w-full" />
            </motion.div>
          </TableCell>
          <TableCell className="w-[40%]">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3, delay: i * 0.05 }}
            >
              <Skeleton className="h-4 w-full" />
            </motion.div>
          </TableCell>
          <TableCell className="w-[20%]">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3, delay: i * 0.05 }}
            >
              <Skeleton className="h-4 w-full" />
            </motion.div>
          </TableCell>
          <TableCell className="w-[30%]">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3, delay: i * 0.05 }}
            >
              <Skeleton className="h-4 w-full" />
            </motion.div>
          </TableCell>
          <TableCell className="w-[100px] text-right">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3, delay: i * 0.05 }}
            >
              <Skeleton className="h-4 w-10 ml-auto" />
            </motion.div>
          </TableCell>
        </TableRow>
      ))}
    </>
  );
}
